import type { RefObject, Ref } from 'react';

export function isRefObject<T>(ref: Ref<T>): ref is RefObject<T> {
  return typeof ref !== 'function' && ref !== null && 'current' in ref;
}
